/** sessionStorage key for the draft `PendingListing` id used for photo uploads (listing onboarding + public tour success) */
export const PENDING_LISTING_ID_KEY = 'pending-listing-id'
